import { render, staticRenderFns } from "./serverTagHoverDown.vue?vue&type=template&id=13397592&scoped=true&"
import script from "./serverTagHoverDown.vue?vue&type=script&lang=js&"
export * from "./serverTagHoverDown.vue?vue&type=script&lang=js&"
import style0 from "./serverTagHoverDown.vue?vue&type=style&index=0&id=13397592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13397592",
  null
  
)

component.options.__file = "serverTagHoverDown.vue"
export default component.exports